module.exports = __webpack_public_path__ + "img/indian-rupee-sign.2147a8c0.svg";